import { create } from "zustand";
import { persist } from "zustand/middleware";
// TO DO => Better namings
export type ChatListState = {
  chatListSyncing: boolean;
  finishedLoadingFirstPageOfChatList: boolean;
  finishedLoadingFullChatList: boolean;
  skipChat: number;
};

type Actions = {
  setChatListSyncing: (val: boolean) => void;
  setFinishedLoadingFirstPageOfChatList: (val: boolean) => void;
  setFinishedLoadingFullChatList: (val: boolean) => void;
  updateSkipChat: (val: number) => void;
  resetChatListState: () => void;
};

const initialState: ChatListState = {
  chatListSyncing: false,
  finishedLoadingFirstPageOfChatList: false,
  finishedLoadingFullChatList: false,
  skipChat: 0,
};

export const useChatListState = create<ChatListState & Actions>()(
  persist(
    (set) => ({
      // State
      ...initialState,

      // Actions
      setChatListSyncing: (val) => set({ chatListSyncing: val }),

      setFinishedLoadingFirstPageOfChatList: (
        finishedLoadingFirstPageOfChatList,
      ) => set({ finishedLoadingFirstPageOfChatList }),

      updateSkipChat: (val) =>
        set((state) => ({
          skipChat: state.skipChat + val,
        })),

      setFinishedLoadingFullChatList: (finished) =>
        set({ finishedLoadingFullChatList: finished }),

      resetChatListState: () => set(initialState),
    }),
    {
      name: "chat-list",
      version: 2,
      partialize: (state) => ({
        finishedLoadingFirstPageOfChatList:
          state.finishedLoadingFirstPageOfChatList,
        finishedLoadingFullChatList: state.finishedLoadingFullChatList,
        skipChat: state.skipChat,
        /*
         * chatListSyncing is intentionally excluded from persistence
         * because we need it to turn true when sync starts
         */
      }),
      onRehydrateStorage: () => (state) => {
        // Ensure chatListSyncing is always false when rehydrating
        if (state) {
          state.chatListSyncing = false;
        }
      },
    },
  ),
);
